import { createAsyncThunk } from '@reduxjs/toolkit';

import { selectProjects } from 'store/projects/selectors/projectsSelectors';
import { selectUserActiveEmployerBusinessId } from 'store/user/selectors.js/user.selectors';
import { selectLoadedAssignmentProjectIds } from '../selectors/assignment.selectors';
import { getProjectAssignments } from '../services/getProjectAssignments';

export const loadAssignmentsForProjects = createAsyncThunk(
  'assignments/loadAssignmentsForProjects',
  async (projectIds, { getState }) => {
    const alreadyLoadedProjectIds =
      selectLoadedAssignmentProjectIds(getState());
    const activeEmployerBusinessId =
      selectUserActiveEmployerBusinessId(getState());
    const projectEntities = selectProjects(getState());

    const isProjectOfActiveEmployerBusiness = (projectId) => {
      const project = projectEntities[projectId];

      return (
        Boolean(project?.business_id) &&
        project.business_id === activeEmployerBusinessId
      );
    };

    const shadowProjectIds = activeEmployerBusinessId
      ? projectIds
          .filter((projectId) => !isProjectOfActiveEmployerBusiness(projectId))
          .map((projectId) => `${projectId}_${activeEmployerBusinessId}`)
      : [];

    const allProjectIds = [...projectIds, ...shadowProjectIds];

    const projectIdsToLoad = allProjectIds.filter(
      (projectId) => !alreadyLoadedProjectIds.includes(projectId)
    );

    if (projectIdsToLoad.length === 0) {
      return { assignments: [], loadedProjectIds: [] };
    }

    const projectAssignments = await Promise.allSettled(
      projectIdsToLoad.map((id) =>
        getProjectAssignments(id, activeEmployerBusinessId)
      )
    );

    const successfulAssignments = projectAssignments
      .filter((result) => result.status === 'fulfilled')
      .map((result) => result.value)
      .flat();

    return {
      assignments: successfulAssignments,
      loadedProjectIds: projectIdsToLoad,
    };
  }
);
